<div fxLayout="row" fxLayoutAlign="end start" class="message-container">
  <div class="w-full message-block" fxLayout="column">
    <h5>{{ title }}</h5>
    <ng-content></ng-content>
  </div>
  <mat-icon class="close-icon font-sm" *ngIf="canDismiss" (click)="dismissMessage.emit()"
    >close</mat-icon
  >
</div>
